import { Color } from 'cesium';
import { EntityMapEntity } from './facility-pin.service';
import { CameraService } from './camera.service';
import { CoreService } from './core.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataContextService } from './data-context.service';
import { TimelineService } from './timeline.service';
export class ShapeMapEntity extends EntityMapEntity {
  // Removed all protected property redeclarations since they're already inherited as public
  // from BaseMapEntity through EntityMapEntity
  constructor(
    mapEntityName: string,
    mapEntityLayerPath: string,
    cameraService: CameraService,
    coreService: CoreService,
    windowService: WindowService,
    dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService
  ) {
    super(mapEntityName, mapEntityLayerPath, cameraService, coreService, windowService, dataContext, modalService, timelineService);
    this.windowId = 'window-' + this.id;
  }

  public init(mapEntityName: string, mapEntityLayerPath: string): void {
    this.initialize(mapEntityName, mapEntityLayerPath);
  }

  public override hide(): void {
    if (this.cesiumEntity) {
      this.cesiumEntity.show = false;
    }
  }

  public override show(): void {
    if (this.cesiumEntity) {
      this.cesiumEntity.show = true;
    }
  }

  public override setTimestamp(date: string): void {
    this.timestamp = new Date(date);
  }

  public override setShowInLayersUI(show: boolean): void {
    this.isVisibleInLayersUI = show;
  }

  public setOutline(color: Color): void {
    if (this.cesiumEntity?.polygon) {
      this.cesiumEntity.polygon.outlineColor = color;
    }
  }

  public setShowOutline(show: boolean): void {
    if (this.cesiumEntity?.polygon) {
      this.cesiumEntity.polygon.outline = show;
    }
  }

  public setOutlineWidth(width: number): void {
    if (this.cesiumEntity?.polygon) {
      this.cesiumEntity.polygon.outlineWidth = width;
    }
  }


  public override buildEntity(): void {
    // Call parent buildEntity if it exists
    super.buildEntity();
    // Initialize cesiumEntity with polygon property
    this.cesiumEntity = { 
      polygon: {},
      id: this.id,
      name: this.name,
      show: true
    };
  }

  public override getCesiumEntity(): any {
    if (!this.cesiumEntity) {
      this.buildEntity();
    }
    return this.cesiumEntity;
  }

  public getHeight(): number {
    return this.centerpoint.altitude || 0;
  }

  public override isPrimitive(): boolean {
    return false;
  }
}